import { StoreState } from 'types';

import { ActionsAction, actionsReducer } from './actions';
import authReducer, { AuthAction } from './auth';
import { DroneAction, droneReducer } from './drone';
import editReducer, { EditAction } from './edit';
import goReducer, { GOAction } from './go';
import loadingReducer, { LoadingAction } from './loading';
import mapReducer, { MapAction } from './map';
import { MessagesAction, messagesReducer } from './messages';
import { PrintAction, printReducer } from './print';
import searchReducer, { SearchAction } from './search';
import visualizationReducer, { VisualizationAction } from './visualization';
import workordersReducer, { WorkordersAction } from './workorders';

export type Action =
  | ActionsAction
  | AuthAction
  | DroneAction
  | EditAction
  | GOAction
  | LoadingAction
  | MapAction
  | MessagesAction
  | PrintAction
  | SearchAction
  | VisualizationAction
  | WorkordersAction;

export default function rootReducer(state: StoreState, action: Action): StoreState {
  return {
    actions: actionsReducer(state.actions, action as ActionsAction),
    auth: authReducer(state.auth, action as AuthAction),
    drone: droneReducer(state.drone, action as DroneAction),
    edit: editReducer(state.edit, action as EditAction),
    go: goReducer(state.go, action as GOAction),
    loading: loadingReducer(state.loading, action as LoadingAction),
    map: mapReducer(state.map, action as MapAction),
    messages: messagesReducer(state.messages, action as MessagesAction),
    print: printReducer(state.print, action as PrintAction),
    search: searchReducer(state.search, action as SearchAction),
    visualization: visualizationReducer(state.visualization, action as VisualizationAction),
    workorders: workordersReducer(state.workorders, action as WorkordersAction),
  };
}
